<template>
  <v-progress-linear
      :striped="day.used > week_ext_data[index]"
      :color="day_progress(day.used)"
      height="30" rounded="lg"
      class="mb-2"
      :max="week_ext_data[index]" :model-value="day.used"
  >
    <v-sheet color="transparent" width="100%" class="d-flex justify-space-between align-center">
      <span class="ml-2">
        <v-icon :icon="['fas', 'caret-right']" v-if="is_today" class="mr-1" />
        <span :class="{'font-weight-bold' : is_today}" class="mr-1">{{ moment(day.date).startOf('days').format('DD') }}</span>
        <span style="font-size: 12px; opacity: 0.4;">{{ moment(day.date).startOf('days').format('dd') }}</span>
      </span>
      <v-chip size="small" color="white" variant="flat" density="compact" class="mr-2" style="opacity: 1;" rounded="sm">
        {{ used }} / {{ week_ext_data[index] }}
      </v-chip>
    </v-sheet>
  </v-progress-linear>
</template>

<script>

import { WeekDura } from "@/store/wp_planner/specialists.store";
import moment from "moment/moment";

export default {
  name: "Header__WP_Calendar",
  props: ['index', 'day'],
  data() {
    return {
      moment: moment,
    }
  },
  methods: {
    day_progress: function (value) {
      if (value > 100) return 'red'
      if (value > 90 && value <= 100) return 'green'
      if (value > 80 && value <= 90) return 'light-green'
      if (value > 70 && value <= 80) return 'lime'
      if (value > 50 && value <= 70) return 'amber'
      if (value > 30 && value <= 50) return 'orange'
      if (value > 10 && value <= 30) return 'deep-orange'
      if (value > 0 && value <= 10) return 'brown'
      if (value <= 0) return 'brown'
    },
  },
  computed: {
    used() {
      return this.day.used
    },
    is_today() {
      return moment(this.day.date).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')
    },
    week_ext_data() {
      return WeekDura().get()
    },
  }
}
</script>

<style scoped>

</style>
